import { render, staticRenderFns } from "./MediaAssets.vue?vue&type=template&id=f5a3da20&scoped=true&"
import script from "./MediaAssets.vue?vue&type=script&lang=js&"
export * from "./MediaAssets.vue?vue&type=script&lang=js&"
import style0 from "./MediaAssets.vue?vue&type=style&index=0&id=f5a3da20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a3da20",
  null
  
)

export default component.exports